// This icon file is generated automatically.
var PDisconnectOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 2a3.38 3.38 0 00-4.77 0L5.7 3.5l.8.8L8.03 2.8a2.24 2.24 0 013.18 0c.93.93.84 2.34 0 3.18L9.7 7.5l.8.8L12 6.77a3.38 3.38 0 000-4.78zM5.99 11.2c-.84.84-2.26.93-3.2 0a2.24 2.24 0 010-3.19l1.52-1.5-.8-.8L2 7.21a3.38 3.38 0 104.77 4.79l1.52-1.52-.8-.8-1.51 1.52zM3.07 2.27a.13.13 0 00-.18 0l-.62.62a.13.13 0 000 .18l8.66 8.66c.05.05.13.05.18 0l.62-.62a.13.13 0 000-.18L3.07 2.27z", "fill-rule": "nonzero" } }] }, "name": "p-disconnect", "theme": "outlined" };
export default PDisconnectOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDisconnectOutlined.js
// module id = 3337
// module chunks = 0